import {Print} from "../utils/print";

const usePrint = (fetchData) => {
    const handlePrint = async (params) => {
        try {
            const response = await fetchData(params.requestParams);
            Print(response, params.name, params.height = 600, params.width = 800, params.download);
        } catch (err){
            console.log("Error fetching report types: " + err);
        }
    };

    return { handlePrint };

};

export default usePrint;
